"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCountry = exports.isCountry = void 0;
var yup = require("yup");
var Referral_1 = require("./Referral");
var countrySchema = yup.object().shape({
    id: yup.string().required(),
    banners: yup.array().of(yup.object()).optional(),
    callingCode: yup.string().required(),
    customerSupportPhone: yup.string().optional(),
    defaultWarehouseId: yup.string().required(),
    saleorUrl: yup.string().required(),
    saleorPasswordResetUrl: yup.string().required(),
    saleorVerifyEmailUrl: yup.string().required(),
    helpCenterUrl: yup.string().required(),
    privacyUrl: yup.string().required(),
    termsUrl: yup.string().required(),
    trendingSearches: yup.array().of(yup.object()).optional(),
    isMarketingEnabled: yup.boolean().required(),
    isTemporarilyClosed: yup.boolean().optional(),
    minVoucherOrderValue: yup.number().required(),
    minFreeDeliveryOrderValue: yup.number().required(),
    minFreeDeliveryBarOrderValue: yup.number().required(),
    minDistanceLocationWarning: yup.number().required(),
    currency: yup.string().required(),
    supportEmail: yup.string().required(),
    isDisabled: yup.boolean().optional(),
    isUppercaseZip: yup.boolean().optional(),
    carousels: yup.array().of(yup.object()).optional(),
    referral: Referral_1.referralSchema.required(),
    neededOrderRatingsForAppRating: yup.number().required(),
    productLimit: yup.number().optional(),
    riderTips: yup.array().of(yup.number()).optional(),
    searchGQLUrl: yup.string().optional(),
    searchInputDebounceValue: yup.number().optional(),
});
function isCountry(obj) {
    return countrySchema.isValidSync(obj);
}
exports.isCountry = isCountry;
function validateCountry(obj) {
    return countrySchema.validateSync(obj);
}
exports.validateCountry = validateCountry;
